import * as React from "react";
import { useAuth } from '../../App';
import { FileUpload } from "soprasteria-ui-library";
import { IListItem } from "soprasteria-ui-library/dist/models/IFormInput";
import { megaBytesToBytes } from '../../helpers/FileHelper';
import { IUploadFileConfiguration } from "../../models/IUploadFileConfiguration";
import { UploadFileConfigurationApi } from "../../api/UploadFileConfigurationApi";

interface IFileUpload {
    isEditable: boolean;
    attachmentCategories?: IListItem[];
    filesSelected?: boolean;
    numOfFiles?: (num: number) => void | undefined;
}

export const LibrettoFileUpload: React.FunctionComponent<IFileUpload> = ({ isEditable, attachmentCategories, numOfFiles }) => {

    const auth = useAuth();
    const uploadFileConfigurationApi = new UploadFileConfigurationApi(auth);
    const [uploadFileConfiguration, setuploadFileConfiguration] = React.useState<IUploadFileConfiguration>();


    React.useEffect(() => {
        uploadFileConfigurationApi.getUploadFileConfigurations((configs) => {
            setuploadFileConfiguration(configs);
        });
    }, []);


    return (
        <FileUpload name="documents"
            label="Dokument"
            maxSizeBytes={megaBytesToBytes(uploadFileConfiguration?.maxFileSizeInMb ? uploadFileConfiguration.maxFileSizeInMb : 0)}
            allowedFileTypes={uploadFileConfiguration?.validFileExtensions ? uploadFileConfiguration.validFileExtensions : []}
            multiple
            inlineLabel
            documentType={isEditable ?
                {
                    documentTypes: attachmentCategories ?? [],
                    documentTypesName: "documentTypeCategoryIds"
                }
                : undefined
            }
            labelCol={2}
            inputCol={10}
            numOfFiles={numOfFiles}
        />
    )
}